var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroundLarge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1200,
    height: 720,
    viewBox: "0 0 1200 720",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 720,
    rx: 8,
    fill: "#024929"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M602 52H1148V180H1012H1008V184V456V460H1012H1148V588H602V403.977C647.468 402.914 684 365.723 684 320C684 274.277 647.468 237.086 602 236.023V52ZM680 320C680 363.514 645.259 398.914 602 399.975V325.659C604.33 324.835 606 322.612 606 320C606 317.388 604.33 315.165 602 314.341V240.025C645.259 241.086 680 276.486 680 320ZM598 314.341V240.025C554.741 241.086 520 276.486 520 320C520 363.514 554.741 398.914 598 399.975V325.659C595.67 324.835 594 322.612 594 320C594 317.388 595.67 315.165 598 314.341ZM516 320C516 274.277 552.532 237.086 598 236.023V52H52V180H188H192V184V456V460H188H52V588H598V403.977C552.532 402.914 516 365.723 516 320ZM1152 52V180V184V256V260V380V384V456V460V588V592H1148H602H598H52H48V588V460V456V384V380V260V256V184V180V52V48H52H598H602H1148H1152V52ZM52 260V380H108V260H52ZM52 384V456H188V184H52V256H108H112V260V380V384H108H52ZM1148 184V256H1092H1088V260V380V384H1092H1148V456H1012V184H1148ZM1148 380H1092V260H1148V380Z",
    fill: "#059D59"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroundLarge);
export default __webpack_public_path__ + "static/media/Ground-Large.61727e1ead5d9d3033bd0a28c1ef16bf.svg";
export { ForwardRef as ReactComponent };